// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2NNgL","footerArrow":"Footer_footerArrow__BVLjd","footerCount":"Footer_footerCount__33lhV","footerClearButton":"Footer_footerClearButton__1TXn7"};